"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formValueToData = exports.transformNullableStringValue = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ramda = require("ramda");

var _messaging = require("./messaging.types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transformNullableStringValue = {
  output: function output(value) {
    return value !== null && value !== void 0 ? value : '';
  },
  input: function input(value) {
    return (value === null || value === void 0 ? void 0 : value.trimLeft()) || null;
  }
};
exports.transformNullableStringValue = transformNullableStringValue;

var formValueToData = function formValueToData(value) {
  var _value$video;

  return _objectSpread(_objectSpread({}, value), {}, {
    [_messaging.MessagingDataFields.MeetingHosts]: (0, _ramda.omit)([_messaging.MeetingHostsFields.IsAttendeeEnabled], value[_messaging.MessagingDataFields.MeetingHosts]),
    [_messaging.MessagingDataFields.VideoData]: (_value$video = value.video) !== null && _value$video !== void 0 && _value$video.type ? {
      type: value.video.type,
      embed: value.video.type === _messaging.MessageVideoType.Embed ? value.video.embed : null,
      vidyard: value.video.type === _messaging.MessageVideoType.Vidyard ? value.video.vidyard : null
    } : null
  });
};

exports.formValueToData = formValueToData;